<template>
  <iframe :src="url" class="iframeModule" ref="iframe"></iframe>
</template>

<script>
export default {
  data() {
    return {
      url: "",
    };
  },
  created() {
    const url = location.href.split("other-page?url=")[1];

    this.url = decodeURIComponent(url);
    console.log(this.url);
  },
};
</script>

<style lang="scss" scoped>
.iframeModule {
  width: 100%;
  min-height: calc(100vh);
  border: none;
}
</style>
